<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X4OGCb/tc-custom/9781611173383.jpg?1720281046088" alt="This image is the cover for the book Blessed Experiences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blessed Experiences
      </h1>
      <p class="bookDescription body article font2">
        <b>“Shares lessons learned on his way from the Jim Crow South to a top spot on Capitol Hill . . . [a] remarkably candid new memoir” —<i>NPR</i></b><br/><br/>From his humble beginnings in Sumter, South Carolina, to his prominence on the Washington, D.C., political scene as the third highest-ranking Democrat in the House of Representatives, US Congressman James E. Clyburn has led an extraordinary life. In <i>Blessed Experiences</i>, Clyburn tells in his own inspirational words how an African American boy from the Jim Crow-era South was able to beat the odds to achieve great success and become, as President Barack Obama describes him, “one of a handful of people who, when they speak, the entire Congress listens.”<br/><br/>Born in 1940 to a civic-minded beautician and a fundamentalist minister, Clyburn began his ascent to leadership at the age of twelve, when he was elected president of his National Association for the Advancement of Colored People (NAACP) youth chapter. He broke barriers through peaceful protests and steadfast beliefs in equality and justice. As a civil rights leader at South Carolina State College, as human affairs commissioner under John C. West and three subsequent governors, and as South Carolina’s first African American congressman since 1897, Clyburn has established a long and impressive record of public leadership and advocacy for human rights, education, historic preservation, and economic development.<br/><br/><b>Includes a foreword from Emmy Award–winning actress and the congressman’s longtime friend Alfre Woodard</b><br/><br/><b>“<i>Blessed Experiences</i> has captured not just the history of this tireless leader’s more-than-four decades in public service, but also a sense of the times.” —Warren Buffett</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James E. Clyburn, Alfre Woodard
      </h2>
      
      <p class="authorDescription body article"><P>James E. Clyburn has represented South Carolina's sixth district in the U.S. House of Representatives since 1993, and he currently serves as assistant Democratic leader of the House. He has been married to the former Emily England since June 1961, and they have three daughters, two sons-in-law, and three grandchildren. The congressman and his wife live in Columbia, South Carolina.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23bb5bbd